/**
 * Evalúa flags y valores de environment que pueden venir sustituidos por pipeline
 * o como tokens sin sustituir (#{NOMBRE}#).
 */
export function isUnreplacedConfigToken(value: unknown): boolean {
  if (value == null || value === '') {
    return true;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return true;
    }
    return value.every((item) => isUnreplacedConfigToken(item));
  }
  const str = String(value).trim();
  return str.startsWith('#{') && str.endsWith('}#');
}

export function isConfigFlagEnabled(value: unknown): boolean {
  if (value === true) {
    return true;
  }
  if (value === false || value == null || value === '') {
    return false;
  }
  if (isUnreplacedConfigToken(value)) {
    return false;
  }
  return String(value).trim().toLowerCase() === 'true';
}

export function resolveConfigString(value: unknown, fallback: string): string {
  if (isUnreplacedConfigToken(value)) {
    return fallback;
  }
  return String(value);
}

export function resolveConfigStringArray(
  value: unknown,
  fallback: string[]
): string[] {
  if (!Array.isArray(value) || value.length === 0 || isUnreplacedConfigToken(value)) {
    return fallback;
  }
  const resolved = value
    .map((item) => String(item).trim())
    .filter((item) => item.length > 0 && !isUnreplacedConfigToken(item));
  return resolved.length > 0 ? resolved : fallback;
}

export function isHasLoginMicrosoftEnabled(
  getConfig: (key: string) => unknown
): boolean {
  return isConfigFlagEnabled(getConfig('HAS_LOGIN_MICROSOFT'));
}
